export const MESSAGES = {
  ERROR_FETCH: "Error fetching data.",
  ERROR_CREATE: "Failed to create/update user.",
  ERROR_DELETE: "Failed to delete user.",
  SUCCESS_CREATE: "User saved successfully.",
  SUCCESS_DELETE: "User deleted successfully.",
};

export const DEFAULT_FORM_VALUES = {
  email: "",
  name: "",
  nickname: "",
  password: "",
  roles: [],
  permits: [],
};

export const QUERY_OPTIONS_CACHE = {
  staleTime: Infinity,
  cacheTime: Infinity,
};
